import { render, staticRenderFns } from "./bid-items.vue?vue&type=template&id=6ca9e1d4&"
import script from "./bid-items.vue?vue&type=script&lang=js&"
export * from "./bid-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports